export enum ApprovalRequestActionEnum {
    // Run the object immediately after approval.
    Start = 1,
    // Register the object in the scheduler after approval.
    Schedule = 2,
    // Apply the requested content to the object without starting it.
    Update = 3,
}

export enum ApprovalRequestStateEnum {
    // Waiting for an approver to respond.
    Pending = 1,
    Approved = 2,
    Rejected = 3,
    // Withdrawn before it was answered, either explicitly or because the requested object changed.
    Cancelled = 4,
    // Nobody responded before the deadline.
    Missed = 5,
}

export enum ApprovalRequestPriorityEnum {
    Low = 1,
    Normal = 2,
    High = 3,
}
